import { defineStore } from 'pinia';
import apiClient from '@/util/apiClient';

function isDemoRecipient(recipient) {
	return String(recipient?.name ?? '').includes('[DEMO]');
}

export const useSiteBroadcastStore = defineStore('siteBroadcastStore', {
	state: () => ({
		loading: false,
		recipientsLoading: false,
		lastBroadcast: null,
		recipients: [],
		error: null
	}),

	actions: {
		async fetchRecipients(params = {}) {
			this.recipientsLoading = true;
			this.error = null;

			try {
				const { data } = await apiClient.get('/broadcasts/recipients', {
					params,
					paramsSerializer: {
						indexes: null
					}
				});

				this.recipients = Array.isArray(data) ? data.filter((recipient) => !isDemoRecipient(recipient)) : [];
				return this.recipients;
			} catch (error) {
				this.recipients = [];
				this.error = error?.response?.data?.message || 'Failed to load broadcast recipients.';
				throw error;
			} finally {
				this.recipientsLoading = false;
			}
		},

		async sendBroadcast(request) {
			this.loading = true;
			this.error = null;

			try {
				const eligibleUserNumbers = new Set(this.recipients.filter((recipient) => !isDemoRecipient(recipient)).map((recipient) => recipient.userNumber));
				const userNumbers = (request.userNumbers ?? []).filter((userNumber) => userNumber != null && eligibleUserNumbers.has(userNumber));
				if (userNumbers.length === 0) {
					this.error = 'At least one eligible recipient is required.';
					throw new Error(this.error);
				}
				const { data } = await apiClient.post('/broadcasts/send', { ...request, userNumbers });
				this.lastBroadcast = data;
				return data;
			} catch (error) {
				this.error = error?.response?.data?.message || this.error || 'Failed to send broadcast.';
				throw error;
			} finally {
				this.loading = false;
			}
		},

		clearLastBroadcast() {
			this.lastBroadcast = null;
		},

		clearRecipients() {
			this.recipients = [];
		}
	}
});
